import { Dialog, Size } from '@hourly-hds/components';
import SignatureView, { type SignatureStatus } from '../SignatureView';
import styles from './DocumentView.module.css';

interface DocumentViewProps {
  open: boolean;
  url: string;
  onFinish: (signatureStatus: SignatureStatus) => void;
  onClose: () => void;
}

const DocumentView = ({ open, url, onFinish, onClose }: DocumentViewProps) => {
  return (
    <div className={styles.overlay} aria-label="Document View">
      <Dialog open={open} size={Size.ExtraLarge} onClose={onClose}>
        <Dialog.Content>
          <SignatureView url={url} onFinish={onFinish} onError={onClose} />
        </Dialog.Content>
      </Dialog>
    </div>
  );
};

export default DocumentView;
